__turbopack_context__.v({
  "box": "QJH7iq_box",
  "box--noPadding": "QJH7iq_box--noPadding",
  "box--noShadow": "QJH7iq_box--noShadow",
  "box--sentiment-info": "QJH7iq_box--sentiment-info",
  "box--sentiment-warning": "QJH7iq_box--sentiment-warning",
  "box--transparent": "QJH7iq_box--transparent",
});
